import type { TMapFields } from '../../models';
import type { IDraftFirstStepResponse } from '../../api/models';
import type { TResponseFormatData } from '../../models/data';

import { pipe, formatDate, transformFields, pickFieldForArchivarius } from './helpers';

/**
 * Возвращает true в случае, если есть ФИО полностью
 * @param firstName
 * @param lastName
 * @param middleName
 */
export const hasAllFieldsFio = ({ firstName, lastName, middleName }: TResponseFormatData) =>
    Boolean(firstName && lastName && middleName);

/** Добавляет свойство - fullName в объект, если есть ФИО полностью */
const formatFullName = (data: IDraftFirstStepResponse) => {
    const { firstName, lastName, middleName } = data;

    if (hasAllFieldsFio(data))
        return { ...data, fullName: `${lastName} ${firstName} ${middleName}` };

    return data;
};

/**
 * Удаляет пустые свойства с объекта
 * @param obj
 * @example { a: 1, b: undefined, c: null } => { a: 1 }
 */
export const filterEmptyValues = (obj: IDraftFirstStepResponse) =>
    Object.fromEntries(Object.entries(obj).filter(([, v]) => v != null));

/** Адаптирует данные от сервера для передачи их в форму на клиенте */
export const formatResponseDate = (data: IDraftFirstStepResponse, mapField: TMapFields) =>
    pipe(
        // Оставляем только поля архивариуса
        pickFieldForArchivarius,
        // Форматируем дату в формат клиента
        formatDate('toClient'),
        // Форматируем ФИО
        formatFullName,
        // Удаляем пустые поля
        filterEmptyValues,
        // Синхронизируем поля с бэка с полями на клиенте
        transformFields(mapField)
    )(data);
